import { Stack, TextField, Button, Autocomplete } from "@mui/material"

export const EstimateFilter = ({ setFilterArray, copyArray }) => {

    const years = copyArray?.map(a => (a.dateCall.split('-')[0]));
    let yearsNoRepeat = years?.filter((item, index) => {
        return years.indexOf(item) === index;
    }).sort((a, b) => b - a);

    const handleSubmit = (e) => {
        e.preventDefault();

        let filter = e.target.filter.value.toUpperCase();
        const month = monthsNumber[e.target.month?.value] || '';
        const year = e.target.year?.value || '';

        const newFilterArray = copyArray.filter((row) => (row.client.toUpperCase().includes(filter) || row.id === parseInt(filter)) && row.dateCall.split('/')[1].includes(month) && row.dateCall.split('/')[2].includes(year));

        setFilterArray(newFilterArray)
    }

    return (
        <Stack component='form' flexDirection='row' justifyContent='space-around' width='100%' mb='1rem' onSubmit={handleSubmit}>
            <Stack flexDirection='row' flexWrap='wrap' gap={1} justifyContent='space-around' width='100%'>
                <TextField
                    label="Filtrar por nº o por cliente"
                    size="small"
                    name="filter"
                    sx={{ width: '400px' }}
                />
                <Autocomplete
                    disablePortal
                    options={['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre']}
                    sx={{ width: '160px' }}
                    size='small'
                    renderInput={(params) => <TextField name='month'{...params}
                        label="Filtrar por mes" variant="outlined" />}
                />
                <Autocomplete
                    disablePortal
                    options={yearsNoRepeat || []}
                    sx={{ width: '160px' }}
                    size='small'
                    renderInput={(params) => <TextField name='year'{...params}
                        label="Filtrar por año" variant="outlined" />}
                />

                <Button type='submit' >Filtrar</Button>
            </Stack>
        </Stack>
    )
}

const monthsNumber = {
    'enero': '01',
    'febrero': '02',
    'marzo': '03',
    'abril': '04',
    'mayo': '05',
    'junio': '06',
    'julio': '07',
    'agosto': '08',
    'septiembre': '09',
    'octubre': '10',
    'noviembre': '11',
    'diciembre': '12'
}